import Vue from 'vue'
import Vuex from 'vuex'
import { Collecte } from './collecte/index'
import Auth from './Auth'
import Boutique from './Boutique'
import Catalogues from './Catalogues'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        Collecte,
        Auth,
        Boutique,
        Catalogues
    }
})
